function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';

/**
 * @param {boolean} active Whether to enable analytics
 * @param {string} lang Three-letter lang code to include in `page` object
 * @param {object} page https://confluence.churchofjesuschrist.org/display/ContMed/Data+Layer+-+General#DataLayerGeneral-page
 */
export var useAnalytics = function useAnalytics(active, lang, page) {
  var _push = useCallback(function (eventType, data) {
    var _page$info, _window, _window$digitalDataEv, _page$info2, _page$info3, _page$category, _page$category2;
    if (!active) {
      return;
    }
    if (!(page !== null && page !== void 0 && (_page$info = page.info) !== null && _page$info !== void 0 && _page$info.siteName)) {
      console.warn('siteName is missing. Skipping chatbot analytics.');
      return;
    }
    (_window = window).digitalData || (_window.digitalData = []);
    window.digitalDataEvents = _objectSpread(_objectSpread({}, window.digitalDataEvents), {}, {
      component: _objectSpread(_objectSpread({}, (_window$digitalDataEv = window.digitalDataEvents) === null || _window$digitalDataEv === void 0 ? void 0 : _window$digitalDataEv.component), {}, {
        click: 'Component Click',
        formSubmit: 'Form Submit',
        chat: 'Chat'
      })
    });
    var event = eventType.split('.').reduce(function (acc, cur) {
      return acc === null || acc === void 0 ? void 0 : acc[cur];
    }, window.digitalDataEvents);
    if (!event) {
      console.error("Invalid analytics event '".concat(eventType, "'"));
      return;
    }
    window.digitalData.push(_objectSpread(_objectSpread({
      event: event
    }, data), {}, {
      page: _objectSpread(_objectSpread(_objectSpread({}, data.page), page), {}, {
        info: _objectSpread(_objectSpread({}, page === null || page === void 0 ? void 0 : page.info), {}, {
          name: (page === null || page === void 0 || (_page$info2 = page.info) === null || _page$info2 === void 0 ? void 0 : _page$info2.name) || window.location.pathname.substring(1).replace(/\//g, '|').replace(/-/g, ' '),
          siteName: page === null || page === void 0 || (_page$info3 = page.info) === null || _page$info3 === void 0 ? void 0 : _page$info3.siteName,
          language: lang
        }),
        category: _objectSpread(_objectSpread({}, page === null || page === void 0 ? void 0 : page.category), {}, {
          primary: (page === null || page === void 0 || (_page$category = page.category) === null || _page$category === void 0 ? void 0 : _page$category.primary) || 'chatbot',
          type: (page === null || page === void 0 || (_page$category2 = page.category) === null || _page$category2 === void 0 ? void 0 : _page$category2.type) || 'chatbot'
        })
      })
    }));
  }, [active, lang, page]);
  var widgetOpened = useCallback(function () {
    var data = {
      component: {
        info: {
          name: 'ccdops chatbot',
          action: 'open',
          location: 'ccdops chatbot'
        },
        category: {
          primary: 'chat'
        }
      }
    };
    _push('component.chat', data);
  }, [_push]);
  var widgetClosed = useCallback(function () {
    var data = {
      component: {
        info: {
          name: 'ccdops chatbot',
          action: 'close',
          location: 'ccdops chatbot'
        },
        category: {
          primary: 'chat'
        }
      }
    };
    _push('component.chat', data);
  }, [_push]);
  var chatInitiated = useCallback(function () {
    var data = {
      component: {
        info: {
          name: 'ccdops chatbot',
          action: 'start',
          location: 'ccdops chatbot'
        },
        category: {
          primary: 'chat'
        }
      }
    };
    _push('component.chat', data);
  }, [_push]);
  var questionAsked = useCallback(function () {
    var data = {
      component: {
        info: {
          name: 'ccdops chatbot',
          action: 'send'
        },
        category: {
          primary: 'chat'
        }
      }
    };
    _push('component.chat', data);
  }, [_push]);
  var feedbackClicked = useCallback(function (positive) {
    var data = {
      component: {
        info: {
          name: "".concat(positive ? 'positive' : 'negative'),
          location: 'chatbot feedback'
        },
        category: {
          primary: 'feedback'
        }
      }
    };
    _push('component.click', data);
  }, [_push]);
  var feedbackSubmitted = useCallback(function (positive) {
    var data = {
      component: {
        info: {
          name: 'feedback',
          formType: 'ccdops chatbot'
        },
        category: {
          primary: 'form'
        },
        attributes: {
          field: [{
            name: 'positive',
            value: !!positive
          }]
        }
      }
    };
    _push('component.formSubmit', data);
  }, [_push]);
  var learnMoreClicked = useCallback(function () {
    var data = {
      component: {
        info: {
          name: 'learn more'
        },
        category: {
          primary: 'ccdops chatbot'
        }
      }
    };
    _push('component.click', data);
  }, [_push]);
  return {
    widgetOpened: widgetOpened,
    widgetClosed: widgetClosed,
    chatInitiated: chatInitiated,
    questionAsked: questionAsked,
    feedbackClicked: feedbackClicked,
    feedbackSubmitted: feedbackSubmitted,
    learnMoreClicked: learnMoreClicked,
    /** Exported for tests only. Do not use. */
    _push: _push
  };
};